import { FormLabelItem, TDtoWrapper } from '@/shared/lib/forms/form-wrapper.types';
import {
  AssetsOwnershipPart,
  OwnershipList,
  OwnershipType,
} from '@/shared/lib/sj-orm/models/asset.dto';
import { PersonalIdentifierType } from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { CollectionName } from '@/shared/lib/sj-orm/types';

type AssetsOwnershipHelpPart = {
  ownerShipType?: QuestionType.SELECT_FROM_LIST;
  isWithCoOwners?: QuestionType.CHECKBOX;
  owner?: QuestionType.PICK_ARRAY_OF_DTO;
  ownerAddress?: QuestionType.ADDRESS;
  ownerShare?: QuestionType.NUMBER;
  ownerDocument?: QuestionType.PICK_ARRAY_OF_DTO;
  otherOwnerDocuments?: QuestionType.PICK_ARRAY_OF_DTO;
  phoneNumber?: QuestionType.PHONE_NUMBER;
  email?: QuestionType.EMAIL;
  coOwners?: QuestionType.CO_OWNERS;
};

export type AssetsOwnershipPartType = TDtoWrapper<AssetsOwnershipPart, AssetsOwnershipHelpPart>;

export const AssetsOwnershipFormPartFull: AssetsOwnershipPartType = {
  ownerShipType: {
    type: QuestionType.SELECT_FROM_LIST,
    label: 'forms_assets:common.inputs.ownerShipType.label',
    items: OwnershipList,
    order: 1,
    onChange: (_, __, ___, setValue) => {
      setValue('owner', undefined);
    },
  },
  owner: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    label: 'forms_assets:common.inputs.owner.label',
    items: [CollectionName.BENEFICIARIES, CollectionName.CONTACTS],
    showIf: {
      ownerShipType: {
        value: OwnershipType.INDIRECT,
      },
    },
    order: 2,
    dtoType: PersonalIdentifierType.FREE_BLOCK,
  },
  ownerShare: {
    type: QuestionType.NUMBER,
    label: 'forms_assets:common.inputs.ownershipShare.label',
    order: 2,
  },
  ownerDocument: {
    type: QuestionType.PICK_ARRAY_OF_DTO,
    label: 'forms_assets:common.inputs.ownerDocument.label',
    items: [CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS, CollectionName.PRIVATE_DOCUMENTS],
    mode: 'multiple',
    order: 3,
  },
  contactInfoLabel: {
    type: FormLabelItem.label,
    label: 'forms_assets:common.inputs.contactInfoLabel.label',
    order: 4,
  },
  contactInfoLabelDescription: {
    type: FormLabelItem.text,
    label: 'forms_assets:common.inputs.contactInfoLabelDescription.label',
    order: 5,
  },
  ownerAddress: {
    type: QuestionType.ADDRESS,
    label: 'forms_assets:common.inputs.ownerAddress.label',
    order: 6,
  },
  phoneNumber: {
    type: QuestionType.PHONE_NUMBER,
    label: 'forms_assets:common.inputs.phoneNumber.label',
    order: 7,
  },
  email: {
    type: QuestionType.EMAIL,
    label: 'forms_assets:common.inputs.email.label',
    order: 8,
  },
  isWithCoOwners: {
    type: QuestionType.CHECKBOX,
    label: 'forms_assets:common.inputs.isWithCoOwners.label',
    order: 9,
    colSpan: 2,
  },
  coOwners: {
    type: QuestionType.CO_OWNERS,
    label: 'forms_assets:common.inputs.coOwners.label',
    order: 9,
    colSpan: 2,
    showIf: {
      isWithCoOwners: { value: true },
    },
  },
};

export const assetsOwnershipBuilder = (excludeItems?: Array<keyof AssetsOwnershipPart>) => {
  if (!Array.isArray(excludeItems) || !excludeItems.length) {
    return {
      form: AssetsOwnershipFormPartFull,
    };
  }

  const copy = Object.assign({}, AssetsOwnershipFormPartFull);

  let cursor = 0;
  const length = excludeItems.length;

  while (cursor < length) {
    delete copy[excludeItems[cursor]];
    cursor++;
  }

  return {
    form: copy,
  };
};
